'use strict';

var cov_12czxdznnt = function () {
    var path = '/home/lobo/repos/meetings-app/src/index.js',
        hash = '799421ff6a6ab92c3f63bbc61a1a159901df8d63',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '1': {
                start: {
                    line: 30,
                    column: 4
                },
                end: {
                    line: 30,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 36,
                    column: 6
                }
            },
            '3': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 66
                }
            },
            '4': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 75
                }
            },
            '5': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 75
                }
            },
            '6': {
                start: {
                    line: 37,
                    column: 4
                },
                end: {
                    line: 37,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 29,
                        column: 9
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 85
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 29
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 32,
                        column: 32
                    },
                    end: {
                        line: 32,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 44
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_12czxdznnt.s[0]++;
angular.module('app', ['ui.router', 'restmod', 'restmod.styles.drfPaged', 'ngMaterial', 'satellizer', 'ngFileUpload', 'cgBusy', 'angularMoment', 'angular-loading-bar', 'angular.filter', 'ui.mask', 'as.sortable']).constant('moment', moment).constant('AppSettings', {
    appUrl: 'https://meetings.soloweb.pt',
    apiUrl: 'https://api.meetings.soloweb.pt',
    mediaUrl: 'https://api.meetings.soloweb.pt/static/media'
}).value('cgBusyDefaults', {
    message: '',
    templateUrl: 'app/shared/html/cgbusy/cgbusy.template.html'
}).run(runBlock);

/** @ngInject */
function runBlock($rootScope, AppSettings, UsersTable, MeetingsTable, ProjectsTable) {
    cov_12czxdznnt.f[0]++;
    cov_12czxdznnt.s[1]++;

    $rootScope.AppSettings = AppSettings; // You can now access AppSettings from any component with $root.AppSettings

    cov_12czxdznnt.s[2]++;
    $rootScope.loadStaticData = function () {
        cov_12czxdznnt.f[1]++;
        cov_12czxdznnt.s[3]++;

        $rootScope.users = UsersTable.$all = UsersTable.$search();
        cov_12czxdznnt.s[4]++;
        $rootScope.meetings = MeetingsTable.$all = MeetingsTable.$search();
        cov_12czxdznnt.s[5]++;
        $rootScope.projects = ProjectsTable.$all = ProjectsTable.$search();
    };
    cov_12czxdznnt.s[6]++;
    $rootScope.loadStaticData();
}